export const determineReleaseVersion = (version?: string) => {
  if (version) {
    return version;
  }

  // @ts-ignore
  const filepathA = document.currentScript.src;

  const scripts = document.getElementsByTagName("script");
  const filepathB = scripts[scripts.length - 1].src;

  const result = (filepathA || filepathB)?.match(/main\.(.*)\.js$/)?.at(1);
  console.log("tried to determine release version from JS filename:", {
    filepathA,
    filepathB,
    result,
  });
  return result;
};

export default determineReleaseVersion;
